import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to the very top on every route change (pathname or search).
// Prevents pages from "carrying over" the previous scroll position when navigating.
export const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration so our reset always wins.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // Also reset documentElement/body for cross-browser safety.
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
